export enum LDFlags {
  SHOW_RECURRING_VISITOR = 'showRecurringVisitor',
  SHOW_VISIT_FORM_UI_METADATA = 'showVisitFormUiMetadata',
}
